export default __webpack_public_path__ + "static/media/B02.c25af22c.png";